const Usuarios = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Usuarios</h1>
          <p className="text-gray-600 text-sm mt-1">Módulo de gestión de usuarios</p>
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <p className="text-gray-500">Selecciona una opción del menú lateral para continuar.</p>
      </div>
    </div>
  )
}

export default Usuarios